<nb-card class="dialog-card">
  <nb-card-header>{{ title | translate}}</nb-card-header>
  <nb-card-body class="flex-centered">
    <div class="container" [innerHTML]="body | translate"></div>
  </nb-card-body>
  <nb-card-footer>
    <button (click)="cancel()" [ngClass]="leftButtonStyle">{{leftButtonText |translate}}</button>
    <button (click)="remove()" [ngClass]="rightButtonStyle">{{rightButtonText |translate}}</button>
  </nb-card-footer>
</nb-card>
